import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import userManager from '../../utils/userManager';
import { getIn } from '../../utils';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 50px;
  font-size: 16px;
  color: ${props => props.theme.primary};
`;

class Login extends Component {
  componentDidMount() {
    userManager.signinRedirect({
      data: {
        redirectUrl:
          getIn(['location', 'state', 'referrer'], this.props) || '/',
      },
    });
  }

  render() {
    return <Wrapper>{this.props.t('messages.redirecting')}</Wrapper>;
  }
}
export default translate()(Login);
